import React from "react";
import { NavLink, useNavigate } from 'react-router-dom';
import { Button } from "react-bootstrap";
import "./LeftSection.css";
import toyotaLogo from "./assets/toyota.webp"; // Replace with actual paths
import hondaLogo from "./assets/honda.webp";
import nissanLogo from "./assets/nissan.webp";
import mazdaLogo from "./assets/mazda.webp";
import suzukiLogo from "./assets/suzuki.webp";
import mitsubishiLogo from "./assets/mitsubishi.webp";
import daihatsuLogo from "./assets/daihatsu.webp";
import subaruLogo from "./assets/subaru.webp";
import hinoLogo from "./assets/hino.webp";
import volkswagenLogo from "./assets/volkswagen.webp";
import bmwLogo from "./assets/bmw.webp";
import isuzuLogo from "./assets/isuzu.webp";
import lexusLogo from "./assets/lexus.webp";
import mercedesBenzLogo from "./assets/mercedes-benz.webp";
import audiLogo from "./assets/audi.webp";
import audiLogominivan from "./assets/Mini-Van.jpg";
import hatchback from "./assets/hatchback.jpg";
import coupe from "./assets/coupe.jpg";
import sub from "./assets/SUV.jpg";
import pickup from "./assets/Pick-Up.jpg";
import sedan from "./assets/Sedan.jpg";
import van from "./assets/Van.jpg";
import truck from "./assets/Truck.jpg";
import wagon from "./assets/wagon.jpg";
import PriceIcon from "./assets/pricetag.jpg";
import petrol from "./assets/petrol.jpg";
import desiel from "./assets/desiel.jpg";
import electic from "./assets/electic.jpg";
import ethanolffv from "./assets/ethanol-ffv.jpg";
import hybridcar from "./assets/hybrid-car.jpg";
import HybridPetrol from "./assets/Hybrid-(Petrol).jpg";
import HybridDiesel from "./assets/Hybrid-(Diesel).jpg";


const makers = [
    { name: "TOYOTA", logo: toyotaLogo },
    { name: "HONDA", logo: hondaLogo },
    { name: "NISSAN", logo: nissanLogo },
    { name: "MAZDA", logo: mazdaLogo },
    { name: "SUZUKI", logo: suzukiLogo },
    { name: "MITSUBISHI", logo: mitsubishiLogo },
    { name: "DAIHATSU", logo: daihatsuLogo },
    { name: "SUBARU", logo: subaruLogo },
    { name: "HINO", logo: hinoLogo },
    { name: "VOLKSWAGEN", logo: volkswagenLogo },
    { name: "BMW", logo: bmwLogo },
    { name: "ISUZU", logo: isuzuLogo },
    { name: "LEXUS", logo: lexusLogo },
    { name: "MERCEDES BENZ", logo: mercedesBenzLogo },
    { name: "AUDI", logo: audiLogo },
];

const types = [
    { name: "MINI VAN", logo: audiLogominivan },
    { name: "HATCHBACK", logo: hatchback },
    { name: "COUPE", logo: coupe },
    { name: "SUV", logo: sub },
    { name: "PICKUP", logo: pickup },
    { name: "SEDAN", logo: sedan },
    { name: "VAN", logo: van },
    { name: "TRUCK", logo: truck },
    { name: "WAGON", logo: wagon },
];

const categories = [
    { name: 'Petrol', logo: petrol },
    { name: 'Disel', logo: desiel },
    { name: 'Electric', logo: electic },
    { name: 'Ethanol-FFV', logo: ethanolffv },
    { name: 'Hybrid', logo: hybridcar },
    { name: 'Hybrid (Diesel)', logo: HybridDiesel },
    { name: 'Hybrid (Petrol)', logo: HybridPetrol },
    { name: 'Semi Hybrid', logo: hybridcar },
];

const LeftSection = () => {
    const navigate = useNavigate();

    const handleItemClick = (criteria, value) => {
        console.log("Criteria:", criteria, "Value:", value); // Debugging
        navigate(`/search-individual?criteria=${criteria}&value=${value}`);
    };

    return (
        <>
            <div className="left-section">
                {/* Search By Maker */}
                <div className="iconnamebox">
                    <div className="search-by-maker-btn mb-3">
                        Search By Maker
                    </div>
                    <ul className="maker-list">
                        {makers.map((maker, index) => (
                            <li key={index} className="maker-item">
                                <NavLink
                                    to={`/search-individual?criteria=maker&value=${maker.name}`}
                                    className="d-flex align-items-center text-decoration-none text-dark"
                                >
                                    <img src={maker.logo} alt={`${maker.name} logo`} className="maker-logo" />
                                    <span className="maker-name">{maker.name}</span>
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                    <div className="show-more text-center">
                        <NavLink to="/inventory" className="nav-link"><button>Show More</button></NavLink>
                    </div>
                </div>

                {/* Search By Type */}
                <div className="iconnamebox">
                    <div className="search-by-maker-btn mb-3">
                        Search By Type
                    </div>
                    <ul className="maker-list">
                        {types.map((type, index) => (
                            <li key={index} className="maker-item">
                                <NavLink
                                    to={`/search-individual?criteria=body_type&value=${type.name}`} // Changed criteria to body_type
                                    className="d-flex align-items-center text-decoration-none text-dark"
                                >
                                    <img src={type.logo} alt={`${type.name} logo`} className="maker-logo" />
                                    <span className="maker-name">{type.name}</span>
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                    <div className="show-more text-center">
                        <NavLink to="/inventory" className="nav-link"><button>Show More</button></NavLink>
                    </div>
                </div>

                {/* Search By Category */}
                <div className="iconnamebox">
                    <div className="search-by-maker-btn mb-3">
                        Search By Category
                    </div>
                    <ul className="maker-list">
                        {categories.map((category, index) => (
                            <li key={index} className="maker-item">
                                <NavLink
                                    to={`/search-individual?criteria=fuel&value=${category.name}`} // Changed criteria to fuel
                                    className="d-flex align-items-center text-decoration-none text-dark"
                                >
                                    <img src={category.logo} alt={`${category.name} logo`} className="maker-logo" />
                                    <span className="maker-name">{category.name}</span>
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                    <div className="show-more text-center">
                        <NavLink to="/inventory" className="nav-link"><button>Show More</button></NavLink>
                    </div>
                </div>
            </div>
        </>
    );
};

export default LeftSection;